module.exports = __webpack_public_path__ + "static/media/31-park-city.6ba3696b.jpg";